import reducer, { initialState, setPlatformListAction } from './reducer'
import { useEffect, useReducer } from 'react'
import { GET_SUPPLIER_PLATFORM_LIST } from '../../api/Filing'
import { isResponseCodeSuccess } from '../../tools/util'
import { Props } from '.'

export function useSetupHook(props: Props) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const getPlatFormList = async () => {
    if (props.isH5Detail) {
      return
    }
    if (props.platformListData && props.platformListData?.length > 0) {
      dispatch(setPlatformListAction(props.platformListData))
      return
    }
    // return
    const res = await GET_SUPPLIER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setPlatformListAction(res.data))
    }
  }
  useEffect(() => {
    getPlatFormList()
  }, [])

  return {
    state,
  }
}
import reducer, { initialState, setPlatformListAction } from './reducer'
import { useEffect, useReducer } from 'react'
import { GET_SUPPLIER_PLATFORM_LIST } from '../../api/Filing'
import { isResponseCodeSuccess } from '../../tools/util'
import { Props } from '.'

export function useSetupHook(props: Props) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const getPlatFormList = async () => {
    if (props.isH5Detail) {
      return
    }
    if (props.platformListData && props.platformListData?.length > 0) {
      dispatch(setPlatformListAction(props.platformListData))
      return
    }
    // return
    const res = await GET_SUPPLIER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setPlatformListAction(res.data))
    }
  }
  useEffect(() => {
    getPlatFormList()
  }, [])

  return {
    state,
  }
}
